"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxFieldType = void 0;
var BoxFieldType;
(function (BoxFieldType) {
    BoxFieldType["CHECKBOX"] = "CHECKBOX";
    BoxFieldType["DOUBLE"] = "DOUBLE";
    BoxFieldType["DROPDOWNMULTSTRINGS"] = "DROPDOWNMULTSTRINGS";
    BoxFieldType["DATE"] = "DATE";
    BoxFieldType["STRINGBIG"] = "STRINGBIG";
    BoxFieldType["DROPDOWNSTRINGS"] = "DROPDOWNSTRINGS";
    BoxFieldType["STRING"] = "STRING";
    BoxFieldType["DROPDOWNCOLLECTION"] = "DROPDOWNCOLLECTION";
    BoxFieldType["DROPDOWNCOLLECTIONMULT"] = "DROPDOWNCOLLECTIONMULT";
    BoxFieldType["DOUBLERANGE"] = "DOUBLERANGE";
    BoxFieldType["CURRENCY"] = "CURRENCY";
})(BoxFieldType = exports.BoxFieldType || (exports.BoxFieldType = {}));
